import Card from "../ui-elements/Card"
import { useContext } from "react"
import { GlobalContext } from "../GlobalContext"

type Props = {
}

function NoChecklists({
}: Props) {

    const { t } = useContext(GlobalContext)
    return <div className={`animate-fadein w-full mt-2`}>
        <Card fullwidth={true}>
            <div className={` w-full flex flex-col gap-1 items-center justify-center`}>
                <p className={`text-4xl`}>⛔️</p>
                <h4 className={`font-righteous text-brandblue text-2xl`}>{t('Dashboard.NoChecklists.heading')}</h4>
                <p className={`text-lg`}>
                    {t('Dashboard.NoChecklists.goToDashboard')}
                    <a href={`https://dashboard.checqr.net/`} className={`underline`}>{t('Dashboard.NoChecklists.dashboardLink')}</a>
                    {t('Dashboard.NoChecklists.setSomeUp')}
                </p>
            </div>
        </Card>
    </div>
}
export default NoChecklists